export const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';

//# sourceMappingURL=ecom.js.map